import Choices from 'choices.js'

document.querySelectorAll('.fn-rma-form').forEach(rmaForm => {
    var rmaSelects = []
    var rmaType = parseInt(rmaForm.dataset['formType'])

    //disable numberof field if serial number is being filled
    function disEnableNumberField(articleRow)
    {
        let numberOfElem = articleRow.querySelector('input[name*="numberof"]')
        if(numberOfElem)
        {
            articleRow.querySelector('input[name*="serialno"]').addEventListener('input', event => {
                if(event.target.value.length > 0)
                {
                    numberOfElem.value = '1'
                    numberOfElem.disabled = true
                }
                else
                {
                    numberOfElem.disabled = false
                }
            })
        }
    }

    document.querySelectorAll('.fn-clone-wrapper').forEach(wrapper => {
        disEnableNumberField(wrapper.querySelector('fieldset.fn-cloneable'))

        let cloneButton = wrapper.querySelector('.fn-clone-btn')
        let removeButton = wrapper.querySelector('.fn-clone-remove-btn')

        //clone
        cloneButton.addEventListener('click', event => {
            event.preventDefault();

            let clones = wrapper.querySelectorAll(cloneButton.dataset['clone'])

            //clone if less than max
            if(cloneButton.dataset['cloneMax'] > clones.length)
            {
                //check if first is visible
                if(rmaType == 1 && clones.length == 1 && clones[0].parentNode.classList.contains('mm-hidden'))
                {
                    clones[0].parentNode.classList.remove('mm-hidden')
                    clones[0].querySelectorAll('[data-required="1"]').forEach(elem => { elem.required = true; })
                }
                else
                {
                    let toClone = clones[0]
                    let clone = toClone.cloneNode(true)
                    let number = clones.length + 1

                    //remove values
                    clone.querySelectorAll('input,textarea').forEach(inputElem => {
                        inputElem.value = !inputElem.name.includes('numberof') ? '' : '1'
                        inputElem.disabled = false
                        inputElem.id = inputElem.id.replace(/_\d+/, '_'+number)
                    })
                    clone.querySelectorAll('select').forEach(selectElem => {
                        let choicesApplied = selectElem.dataset['choicesapplied']
                        if(typeof choicesApplied != 'undefined' && choicesApplied !== null)
                        {
                            let wrapper = selectElem.closest('.input')
                            wrapper.querySelector('div.choices').remove()

                            selectElem = rmaSelects[parseInt(choicesApplied)].cloneNode(true)

                            wrapper.appendChild(selectElem)
                        }
                        selectElem.selectedIndex = 0
                        selectElem.id = selectElem.id.replace(/_\d+/, '_'+number)

                        makeSelectChoices(selectElem)
                    })
                    clone.querySelectorAll('label').forEach(labelElem => {
                        labelElem.setAttribute('for', labelElem.getAttribute('for').replace(/_\d+/, '_'+number))
                    })

                    //set actual article count
                    if(clone.querySelector('legend span'))
                    {
                        clone.querySelector('legend span').textContent = number
                    }
                    else if(rmaType == 1 && clone.querySelector('legend'))
                    {
                        clone.querySelector('legend').classList.add('mm-hidden')
                    }

                    toClone.parentNode.appendChild(clone)

                    disEnableNumberField(clone)
                }
            }

            //remove hidden from remove button
            if(removeButton)
            {
                removeButton.classList.remove('mm-hidden')
            }
        })

        if(removeButton)
        {
            //remove clone
            removeButton.addEventListener('click', event => {
                event.preventDefault()

                let clones = wrapper.querySelectorAll(removeButton.dataset['clone'])

                if(clones.length > 1)
                {
                    clones[clones.length - 1].remove();

                    if(rmaType == 0 && clones.length == 2)
                    {
                        removeButton.classList.add('mm-hidden')
                    }
                }
                else if(rmaType == 1)
                {
                    clones[0].parentNode.classList.add('mm-hidden')
                    clones[0].querySelectorAll('[data-required="1"]').forEach(elem => { elem.required = false; })
                    removeButton.classList.add('mm-hidden')
                }
            })
        }
    })

    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        rmaForm.querySelectorAll('select').forEach((select, index) => {
            rmaSelects.push(select.cloneNode(true))
            select.dataset['choicesapplied'] = index

            makeSelectChoices(select)
        })
    }

    function makeSelectChoices(select)
    {
        select.closest('.fieldwrap.form-group').classList.add('select')

        new Choices(select, {
                searchEnabled: false,
                itemSelectText: "",
                shouldSort: true});
    }
})